<template>
  <div v-if="qrcodeImage">
    <v-row class="mt-0">
      <v-col cols="12">
        <p class="w-100 text-center subtitle-2">
          Consumidor: {{ customerName }}
        </p>
      </v-col>
      <v-row v-if="isWaiting" class="w-100">
        <v-col cols="12" class="d-flex justify-center">
          <v-img
            max-width="250"
            max-height="250"
            :src="qrcodeImage"
            alt="QR Code de pagamento"
            contain
            class="elevation-1 align-self-center"
          />
        </v-col>
        <v-col cols="12" class="d-flex justify-center">
          <div class="d-flex flex-column align-center qr-actions">
            <v-btn
              color="#e5183d"
              dark
              class="mt-4 qr-copy-button"
              @click="copyQRCodeText"
            >
              Clique para copiar
            </v-btn>
            <p class="subtitle-2 text-center qr-note mt-2">
              O QRCode só pode ser lido no aplicativo da BRPoints
            </p>
          </div>
        </v-col>
      </v-row>
      <v-row v-else-if="status === 'CONFIRMED'" class="w-100">
        <v-col cols="12" class="d-flex justify-center">
          <v-row>
            <v-col cols="12" class="d-flex justify-center">
              <v-icon color="green" size="250">mdi-check-circle</v-icon>
            </v-col>
            <v-col cols="12" class="d-flex justify-center">
              <p class="w-100 text-center subtitle-2">
                Pagamento efetuado com sucesso!
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-else class="w-100">
        <v-col cols="12" class="d-flex justify-center">
          <v-row>
            <v-col cols="12" class="d-flex justify-center">
              <v-icon color="red" size="250">mdi-alert-circle</v-icon>
            </v-col>
            <v-col cols="12" class="d-flex justify-center">
              <p class="w-100 text-center subtitle-2">
                Erro ao receber o pagamento!
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TransactionQrCodePanel",
  props: {
    customerName: {
      type: String,
      default: "",
    },
    qrcodeImage: {
      type: String,
      default: "",
    },
    qrcodeText: {
      type: String,
      default: "",
    },
    status: {
      type: String,
      default: null,
    },
  },
  computed: {
    isWaiting(): boolean {
      return !this.status || this.status === "PENDING";
    },
  },
  methods: {
    async copyQRCodeText() {
      const text = String(this.qrcodeText || "");
      if (!text) return;

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          this.copyWithTextarea(text);
        }

        this.$store.dispatch("showSnack", {
          message: "QRCode copiado com sucesso",
          color: "success",
        });
      } catch {
        try {
          this.copyWithTextarea(text);
          this.$store.dispatch("showSnack", {
            message: "QRCode copiado com sucesso",
            color: "success",
          });
        } catch {
          this.$store.dispatch("showSnack", {
            message: "Não foi possível copiar o QRCode",
            color: "error",
          });
        }
      }
    },
    copyWithTextarea(text: string) {
      // Append inside the panel (dialog content), not document.body.
      // Body is aria-hidden while the modal is open, so select/copy can
      // silently fail and leave the previous clipboard value.
      const host = (this.$el as HTMLElement) || document.body;
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      textarea.style.pointerEvents = "none";
      textarea.style.left = "0";
      textarea.style.top = "0";
      host.appendChild(textarea);
      textarea.focus();
      textarea.select();
      textarea.setSelectionRange(0, text.length);
      const copied = document.execCommand("copy");
      host.removeChild(textarea);
      if (!copied) {
        throw new Error("copy failed");
      }
    },
  },
});
</script>

<style scoped>
.qr-actions {
  gap: 16px;
  max-width: 320px;
}

.qr-copy-button {
  min-width: 220px;
}

.qr-note {
  font-weight: 600;
  color: #23263a;
}
</style>
